/** A failed check (offline, maintenance, older deployment) is not an update. */
export async function hasAppUpdate(version: string, manifestUrl: string, signal: AbortSignal): Promise<boolean> {
  try {
    const response = await fetch(manifestUrl, { cache: 'no-store', signal })
    if (!response.ok) return false
    const manifest: unknown = await response.json()
    return typeof manifest === 'object' && manifest !== null && 'version' in manifest
      && typeof manifest.version === 'string' && manifest.version.length > 0
      && manifest.version !== version
  } catch {
    return false
  }
}
